<style>
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="supplier_invoice" class="label"> {{ $t("supplier_invoice") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('supplier_invoice')"
                                    v-model="inputs.supplier_invoice"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="commission" class="label"> {{ $t("commission") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('commission')"
                                    v-model="inputs.commission"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="bank_charges" class="label"> {{ $t("bank_charges") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('bank_charges')"
                                    v-model="inputs.bank_charges"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="insurance" class="label"> {{ $t("insurance") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('insurance')"
                                    v-model="inputs.insurance"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="ocean_freight" class="label"> {{ $t("ocean_freight") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('ocean_freight')"
                                    v-model="inputs.ocean_freight"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="terminal_charges" class="label"> {{ $t("terminal_charges") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('terminal_charges')"
                                    v-model="inputs.terminal_charges"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="demurrage" class="label"> {{ $t("demurrage") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('demurrage')"
                                    v-model="inputs.demurrage"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="exam_fee" class="label"> {{ $t("exam_fee") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('exam_fee')"
                                    v-model="inputs.exam_fee"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="inland_freight" class="label"> {{ $t("inland_freight") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('inland_freight')"
                                    v-model="inputs.inland_freight"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="custom_br_fee_mex" class="label"> {{ $t("custom_br_fee_mex") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('custom_br_fee_mex')"
                                    v-model="inputs.custom_br_fee_mex"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="custom_br_fee_us/ca" class="label"> {{ $t("custom_br_fee_us/ca") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('custom_br_fee_us/ca')"
                                    v-model="inputs.custom_br_fee_us"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="duty" class="label"> {{ $t("duty") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('duty')"
                                    v-model="inputs.duty"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="inspection_charges" class="label"> {{ $t("inspection_charges") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('inspection_charges')"
                                    v-model="inputs.inspection_charges"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="extra_charges" class="label"> {{ $t("extra_charges") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('extra_charges')"
                                    v-model="inputs.extra_charges"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="carrying_charges" class="label"> {{ $t("carrying_charges") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('carrying_charges')"
                                    v-model="inputs.carrying_charges"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="inv_to_customer" class="label"> {{ $t("inv_to_customer") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('inv_to_customer')"
                                    v-model="inputs.inv_to_customer"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="total_cost" class="label"> {{ $t("total_cost") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('total_cost')"
                                    v-model="inputs.total_cost"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="total_sales" class="label"> {{ $t("total_sales") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('total_sales')"
                                    v-model="inputs.total_sales"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="gross_profit" class="label"> {{ $t("gross_profit") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('gross_profit')"
                                    v-model="inputs.gross_profit"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="percentage" class="label"> {{ $t("percentage") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('percentage')"
                                    v-model="inputs.percentage"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="mt-5 col-md-3 action-buttons">
                        <button type="button" class="btn btn-primary mr-2  w-100" 
                            @click="redirectToForms">
                            {{ $t('continue') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';

export default {
    name: "add_contractDetail_form",
    mixins: [FormMixin],
    data() {
        return {
            inputs: {
                supplier_invoice : null,
                commission : null,
                bank_charges : null,
                insurance : null,
                ocean_freight : null,
                terminal_charges : null,
                demurrage : null,
                exam_fee : null,
                inland_freight : null,
                custom_br_fee_mex : null,
                custom_br_fee_us : null,
                duty : null,
                inspection_charges : null,
                extra_charges : null,
                carrying_charges : null,
                inv_to_customer : null,
                total_cost : null,
                total_sales : null,
                gross_profit : null,
                percentage : null,
            },
            preloader : false,
        }  
    },
    methods: {
        redirectToForms(){
            this.$hub.$emit('change-tab-subtab', 'tab-8');
        }
    },

    watch : {
        inputs : {
            deep : true,
            handler(newVal){

            }
        }
    },

    mounted() {    
    },
}
</script>
